export const showArticlesTable = (totalArticles: number, mainArticleId: number | null, totalTabs: number) => {
    return totalArticles > 0 && !(totalArticles === 1 && !mainArticleId && totalTabs === 0);
}
